/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Why a result sits in the review queue.
 * @export
 */
export const ReviewReason = {
    NearMatch: 'near_match',
    Tolerance: 'tolerance',
    Flag: 'flag'
} as const;
export type ReviewReason = typeof ReviewReason[keyof typeof ReviewReason];


export function instanceOfReviewReason(value: any): boolean {
    for (const key in ReviewReason) {
        if (Object.prototype.hasOwnProperty.call(ReviewReason, key)) {
            if (ReviewReason[key as keyof typeof ReviewReason] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ReviewReasonFromJSON(json: any): ReviewReason {
    return ReviewReasonFromJSONTyped(json, false);
}

export function ReviewReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReviewReason {
    return json as ReviewReason;
}

export function ReviewReasonToJSON(value?: ReviewReason | null): any {
    return value as any;
}

export function ReviewReasonToJSONTyped(value: any, ignoreDiscriminator: boolean): ReviewReason {
    return value as ReviewReason;
}

